import React from 'react'
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons'

import './PasswordChange.css'
import QbHeading from '../shared/QbHeading/QbHeading'
import QbButton from '../shared/QbButton/QbButton'
import QbInput from '../shared/QbInput/QbInput'
import QbLink from '../shared/QbLink/QbLink'
import { RESTORE_WALLET_NAV } from '../../constants/navigation'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import WebMenuHolder from '../shared/WebMenu/WebMenuHolder'


const PasswordChange = ({
  t,
  pwdChangeProfile,
  onPasswordChange,
  onRepeatPasswordChange,
  onPasswordChangeClick,
  errorMessages,
  handleDoneClick
}) => (
    <div className="main-content-container">
      <WebMenuHolder title={t('wallet.password-change-title')} />

      <div className="main-content-body">
        { 
          pwdChangeProfile.passwordChanged ?
          <QbHeading title={t('wallet.password-change.headline-changed')} text={t('wallet.password-change.message-changed')} /> :
          <QbHeading title={t('wallet.password-change.headline')} text={t('wallet.password-change.message')} />
        }

        { 
          pwdChangeProfile.passwordChanged ?
          <div className="password-change-success-content">
            <FontAwesomeIcon
              style={CHECK_STYLE}
              icon={faCheckCircle}
            />
            <QbButton style={{justifySelf: 'end'}} name="Done" onClick={handleDoneClick} />
          </div> :

          <div className="password-change-content">

            <QbInput
              type="password"
              value={pwdChangeProfile.password}
              title={t('wallet.password-change.provide-password-label')}
              errorMessage={t(errorMessages.password)}
              onChange={onPasswordChange}
            />

            <QbInput
              type="password"
              value={pwdChangeProfile.repeatPassword}
              title={t('wallet.password-change.provide-password-label')}
              errorMessage={t(errorMessages.repeatPassword)}
              onChange={onRepeatPasswordChange}
            />

            <div className="main-content-footer">
              <QbLink name={t('button-actions.cancel')} to={RESTORE_WALLET_NAV} />
              <QbButton name="Change password" onClick={onPasswordChangeClick} />
            </div>

          </div>
        }

      </div>
    </div>
)

export default PasswordChange

const CHECK_STYLE = {
  color: '#50B748',
  height: '106px',
  width: '106px'
}


// WEBPACK FOOTER //
// ./src/components/PasswordChange/PasswordChange.js